import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'
import { applyTheme, getStoredTheme } from './shared/theme'
import { applyLook, getStoredLook } from './shared/look'

applyTheme(getStoredTheme())
applyLook(getStoredLook())

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
